import { useEffect, useState } from 'react'

export function useViewportWidth(): number | null {
  const [width, setWidth] = useState(
    typeof window === 'undefined' ? null : window.innerWidth,
  )

  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth)
    }

    // Add the listener, then setWidth to avoid race.
    window.addEventListener('resize', handleResize)
    setWidth(window.innerWidth)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return width
}
